import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import { Create, FormManager, PageTitle, selectUser, UserState } from 'gossamer-front-end';
import { getListRowLink } from 'gossamer-unified';
import { InstitutionGroup } from 'cb-model';
import { useSelector } from 'react-redux';
import { CustomInfo } from 'cb-unified';

export const InstitutionGroupCreate = (): React.JSX.Element => {
  const navigate = useNavigate();
  const user = useSelector((state: { user: UserState }) => selectUser(state));

  return (
    <>
      <PageTitle verb="Create" entity={InstitutionGroup} />
      {user.userId && (
        <FormManager
          compoundUrl="/main/~/institution-group-create"
          handleCancel={() => navigate(`/admin/institution-group/search`)}
          handleSuccess={({ keyOfFirstCreate }) =>
            navigate(getListRowLink(InstitutionGroup.listRowLink, keyOfFirstCreate))
          }
          initialization={{
            main: {
              type: 'create-single',
              entity: InstitutionGroup,
              override: { institution_id: (user.customInfo as CustomInfo)?.adminInstitutionId },
            },
          }}
        >
          <Create valuesKey="main" entity={InstitutionGroup} />
        </FormManager>
      )}
    </>
  );
};
